<template>
    <div class="main-container">
        <el-form :inline="true" :model="searchForm" size="small" ref="searchForm" @keyup.enter.native="handleSearch"
            label-width="70px">
            <el-form-item label="酒店名称" prop="hotelId">
                <el-select v-model="searchForm.hotelId" placeholder="请选择酒店名称" filterable style="width: 250px" remote :remote-method="remoteMethod" :loading="loading" @change="handleSelectHotel">
                    <el-option v-for="item in hotelList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <div></div>
            <el-form-item label="入住人" prop="customerName">
                <el-input v-model="searchForm.customerName" placeholder="请输入入住人" style="width: 210"></el-input>
            </el-form-item>
            <el-form-item label="房间号" prop="roomNo">
                <el-input v-model="searchForm.roomNo" placeholder="请输入房间号" style="width: 210"></el-input>
            </el-form-item>
            <el-form-item label="房型" prop="roomTypeId">
                <el-select v-model="searchForm.roomTypeId" placeholder="请选择房型" clearable style="width: 120px">
                    <el-option v-for="item in roomTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="时间" prop="selectTime">
                <el-date-picker v-model="selectTime" type="daterange" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
                    key="picker1" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                    @change="handleChangeDate"></el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
                <el-button @click="handleReset" size="small">重置</el-button>
            </el-form-item>
        </el-form>

        <el-table border size="small" style="width:100%;margin-top:10px;" :data="tableData" v-loading="isLoading"
            element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-table-column type="index" label="#" align="center"></el-table-column>
            <el-table-column prop="hotelName" label="酒店名称" width="300"></el-table-column>
            <el-table-column prop="roomTypeName" label="房型" width="150"></el-table-column>
            <el-table-column prop="floor" label="楼层" width="150"></el-table-column>
            <el-table-column prop="roomNo" label="房间号" width="200"></el-table-column>
            <el-table-column prop="customerName" label="入住人" width="120"></el-table-column>
            <el-table-column prop="customerMobile" label="手机号" width="200" show-overflow-tooltip></el-table-column>
            <el-table-column prop="days" label="入住天数" width="120"></el-table-column>
            <el-table-column prop="estimatedCheckIn" label="入住时间" align="center" width="200"></el-table-column>
            <el-table-column prop="estimatedCheckOut" label="退房时间" align="center" width="200"></el-table-column>
        </el-table>
        <el-pagination @size-change="handleChangeSize" @current-change="handleChangePage"
            style="text-align:right;margin-top:10px;" :current-page="searchForm.pageNumber" :page-sizes="[10, 20, 50]"
            :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>
</template>

<script>
export default {
    data() {
        return {
            searchForm: {
                hotelId: "",
                customerName: "",
                roomNo: "",
                roomTypeId: "",
                startDate: "",
                endDate: "",
                pageSize: 10,
                pageNumber: 1,
            },
            selectTime: null,
            isLoading: false,
            tableData: [],
            total: 0,
            hotelList: [],
            roomTypeList: []
        }
    },
    created() {
        this.getHotelList("", 1);
    },
    methods: {
        handleChangeDate(date) {
            if (date.length) {
                this.searchForm.startDate = date[0];
                this.searchForm.endDate = date[1];
            }
        },

        handleSearch() {
            this.searchForm.pageNumber = 1;
            this.getTableData();
        },

        handleReset() {
            this.searchForm = {
                hotelId: this.searchForm.hotelId,
                customerName: "",
                roomNo: "",
                roomTypeId: "",
                startDate: "",
                endDate: "",
                pageSize: 10,
                pageNumber: 1,
            };
            this.selectTime = '',
            this.getTableData();
        },

        handleChangePage(page) {
            this.searchForm.pageNumber = page;
            this.getTableData();
        },

        handleChangeSize(size) {
            this.searchForm.pageNumber = 1;
            this.searchForm.pageSize = size;
            this.getTableData();
        },
        getTableData() {
            this.isLoading = true;
            this.getRequest("/api/roomOrder/page", this.searchForm)
                .then(res => {
                    this.isLoading = false;
                    let data = res.data;
                    if (data.code == 200) {
                        this.tableData = data.data.records;
                        this.total = data.data.total;
                    }
                }).catch(() => {
                    this.isLoading = false;
                })
        },
        handleSelectHotel() {
            this.searchForm.pageNumber = 1;
            this.handleReset();
            this.getRoomTypeList();
        },
        getRoomTypeList() {
            this.getRequest(`/api/roomType/getByHotelId?hotelId=${this.searchForm.hotelId}`)
            .then(res => {
                let data = res.data;
                if (data.code == 200) {
                    this.roomTypeList = data.data;
                }
            })
        },
        remoteMethod(name) {
            if(name) {
                this.getHotelList(name);
            }
        },
        getHotelList(name,key) {
            this.getRequest("/api/hotel/page", {
                pageSize: 10,
                name: name || ''
            }).then(res => {
                let data = res.data;
                if(data.code == 200) {
                    this.hotelList = data.data.records;
                    if(key && this.hotelList.length) {
                        this.searchForm.hotelId = this.hotelList[0].id;
                        this.getTableData();
                        this.getRoomTypeList();
                    }
                }
            })
        },

    },
}
</script>
<style type="less">
@import url("./index.less");
</style>


